import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import UploadPicture from '@blade-sxp/portrait-management/pages/components/upload-picture.vue';
import { Component, Vue } from 'vue-property-decorator';
import { addVehicle, queryAutomobileDetail, updateVehicle } from '@blade-sxp/portrait-management/api/vehicle';
import { Scale } from '@blade/common/utils/auto-scale';
import { PageQueryTypeEnum, VehicleTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import ImageUtil from '@blade-sxp/portrait-management/utils/image-util';
import { PortraitManagementDataModule } from '@blade-sxp/portrait-management/store/index';
const Webapi = {
    addVehicle,
    queryAutomobileDetail,
    updateVehicle,
};
let default_1 = class extends Vue {
    formTextareaRows = 5;
    formLabelWidth = 80 * Scale + 'px';
    formInputMaxLength = 50;
    formNoteInputMaxLength = 50;
    uploadPictureMaxCount = 1;
    form = {
        images: [],
        libIds: [],
        plateNumber: '',
        type: '',
        color: '',
        brand: '',
        plateNumberColor: '',
        plateNumberType: '',
        ownerName: '',
        ownerId: '',
        remark: '',
        automobileLibs: [],
        image: '',
    };
    propsData = { checkStrictly: true, value: 'value', label: 'name', children: 'children', emitPath: false };
    vehicleType = [];
    vehicleColor = [];
    rules = {
        // images: [{ type: 'array', required: true, message: this.$t('imageInputPlaceholder'), trigger: 'change' }],
        plateNumber: [{ required: true, message: this.$t('plateNumberInputPlaceholder'), trigger: 'blur' }],
    };
    submiting = false;
    loading = false;
    // 允许提交
    get allowSubmit() {
        return this.form.plateNumber.length > 0;
    }
    created() {
        this.loading = true;
        this.$router.onReady(async () => {
            const query = this.$route.query;
            if (query.type !== PageQueryTypeEnum.CREATE) {
                await this.queryAutomobileDetail(+query.id);
            }
            this.loading = false;
        });
        PortraitManagementDataModule.getAutomobileTypeOrColor(VehicleTypeEnum.AUTOMOBILE_TYPE).then(() => {
            this.vehicleType = PortraitManagementDataModule.vehicleTypeColorDataListMap[VehicleTypeEnum.AUTOMOBILE_TYPE];
        });
        PortraitManagementDataModule.getAutomobileTypeOrColor(VehicleTypeEnum.AUTOMOBILE_COLOR).then(() => {
            this.vehicleColor = PortraitManagementDataModule.vehicleTypeColorDataListMap[VehicleTypeEnum.AUTOMOBILE_COLOR];
        });
    }
    async queryAutomobileDetail(id) {
        try {
            let result = await Webapi.queryAutomobileDetail(id);
            if (result) {
                let imagesBase64 = [];
                for (let i = 0; i < result.images?.length; i++) {
                    const im = result.images[i];
                    imagesBase64.push((await ImageUtil.urlToBase64(im.path)));
                }
                result.images = imagesBase64;
                this.form = result;
            }
        }
        catch (error) {
            console.log('queryAutomobileDetail error', error);
        }
    }
    handleCancel() {
        this.$router.back();
    }
    handleSubmit() {
        const query = this.$route.query;
        this.$refs['form'].validate((valid) => {
            if (valid) {
                if (query.type === PageQueryTypeEnum.CREATE) {
                    let form = {
                        ...this.form,
                        libIds: [+query.libId],
                        automobileLibs: [
                            {
                                libId: +query.libId,
                                name: query.libName,
                            },
                        ],
                        image: this.form.images?.[0] ?? null,
                        images: [],
                    };
                    this.addVehicle(form);
                }
                else if (query.type === PageQueryTypeEnum.EDIT) {
                    let form = {
                        ...this.form,
                        libIds: [+query.libId],
                        automobileLibs: [
                            {
                                libId: +query.libId,
                                name: query.libName,
                            },
                        ],
                        automobileId: +query.id,
                        image: this.form.images?.[0] ?? null,
                        images: [],
                    };
                    this.updateVehicle(form);
                }
            }
            else {
                console.log('validate error !');
                return false;
            }
        });
    }
    async addVehicle(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.addVehicle(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('createSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) {
            console.log('addVehicle error', error);
        }
        this.submiting = false;
    }
    async updateVehicle(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.updateVehicle(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('editSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) {
            console.log('updateVehicle error', error);
        }
        this.submiting = false;
    }
};
default_1 = __decorate([
    Component({
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    plateNumberInputPlaceholder: 'Please enter plate number',
                    typeInputPlaceholder: 'Please select a type',
                    colorInputPlaceholder: 'Please select a color',
                    brandInputPlaceholder: 'Please enter brand',
                    plateNumberColorInputPlaceholder: 'Please enter plate number color',
                    plateNumberTypeInputPlaceholder: 'Please enter type of plate number',
                    ownerNameInputPlaceholder: 'Please enter owner name',
                    ownerIdInputPlaceholder: 'Please enter owner ID',
                    noteInputPlaceholder: 'Please enter note',
                    imageInputPlaceholder: 'Upload at least one picture',
                },
                zh: {
                    ...lang.zh,
                    plateNumberInputPlaceholder: '请输入车牌号',
                    typeInputPlaceholder: '请选择类型',
                    colorInputPlaceholder: '请选择颜色',
                    brandInputPlaceholder: '请输入品牌',
                    plateNumberColorInputPlaceholder: '请输入车牌颜色',
                    plateNumberTypeInputPlaceholder: '请输入车牌类型',
                    ownerNameInputPlaceholder: '请输入车主名字',
                    ownerIdInputPlaceholder: '请输入车主ID',
                    noteInputPlaceholder: '请输入备注',
                    imageInputPlaceholder: '至少上传一张图片',
                },
            },
        },
        components: {
            UploadPicture,
        },
    })
], default_1);
export default default_1;
